import api from './api';

export const authService = {
  // Login user
  login: async (email, password) => {
    const response = await api.post('/v1/auth/login/', { email, password });
    return response.data;
  },

  // Register user
  register: async (userData) => {
    const response = await api.post('/v1/auth/register/', userData);
    return response.data;
  },

  // Get user profile
  getProfile: async () => {
    const response = await api.get('/v1/auth/profile/');
    return response.data;
  },

  // Update user profile
  updateProfile: async (userData) => {
    const response = await api.put('/v1/auth/profile/', userData);
    return response.data;
  },

  // Change password
  changePassword: async (oldPassword, newPassword) => {
    const response = await api.post('/v1/auth/change-password/', {
      old_password: oldPassword,
      new_password: newPassword,
    });
    return response.data;
  },

  // Refresh token
  refreshToken: async (refreshToken) => {
    const response = await api.post('/v1/auth/refresh/', { refresh: refreshToken });
    return response.data;
  },
};